<template>
  <div>
    {{ totalPeakString }}
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { MeterJson } from '@/data/meters/MeterJson.ts';
import Meter from '@/domain/model/business/Meter.ts';
import Power from '@/domain/model/unit/Power.ts';

export default {
  name: 'TotalPeakInWattCell',
  props: {
    metersJson: { type: Array as PropType<MeterJson[]>, required: true },
  },
  computed: {
    totalPeakString() {
      const totalWatt = this.metersJson
        .map((mJson) => new Meter(mJson))
        .filter((meter) => meter.isActive())
        .reduce((prev, meter) => prev + meter.getPeakInWatt(), 0);
      return Power.ofKw(totalWatt / 1000).toString();
    },
  },
};
</script>

<style scoped></style>
